import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import {
  BillingPaymentMethod,
  BillingTransaction,
  BillingTransactionStatus,
  BillingTransactionType,
} from "@/types/billing-transactions";

export function getPaymentUi(
  tx: BillingTransaction,
  locales: {
    successStatuses: {
      success: string;
      successOffline: string;
      refund: string;
      partialRefund: string;
    };
    failureStatuses: {
      notPaid: string;
      notRefunded: string;
      notCompleted: string;
    };
  },
) {
  const isSuccess = tx.status === BillingTransactionStatus.SUCCEEDED;

  if (isSuccess) {
    return {
      icon: <CheckCircle2 className="h-7 w-7 text-green-600" />,
      title: getSuccessTitle(tx, locales.successStatuses),
      style: "text-light-green border-light-green/50 bg-light-green/5",
    };
  }

  return {
    icon: <XCircle className="h-7 w-7 text-red-600" />,
    title: getFailureTitle(tx.type, locales.failureStatuses),
    style: "text-dark-orange border-dark-orange/50 bg-dark-orange/5",
  };
}

function getSuccessTitle(
  tx: BillingTransaction,
  locales: {
    success: string;
    successOffline: string;
    refund: string;
    partialRefund: string;
  },
) {
  if (tx.type === BillingTransactionType.PAYMENT) {
    return tx.paymentMethod === BillingPaymentMethod.OFFLINE
      ? locales.successOffline
      : locales.success;
  }
  if (tx.type === BillingTransactionType.REFUND) return locales.refund;

  return locales.partialRefund;
}

function getFailureTitle(
  type: BillingTransactionType,
  locales: { notPaid: string; notRefunded: string; notCompleted: string },
) {
  if (type === BillingTransactionType.PAYMENT) return locales.notPaid;
  if (type === BillingTransactionType.REFUND) return locales.notRefunded;

  return locales.notCompleted;
}
